import axios from 'axios';
import { message } from 'antd';

axios.create({
    timeout: 10000, // 请求超时设置
    withCredentials: false // 跨域请求是否需要携带 cookie
});
axios.defaults.baseURL = 'https://test-apaas.grtcloud.net/api';
//开始请求设置，发起拦截处理
axios.interceptors.request.use(
    (config) => {
        // 如果开启 token 认证
        // config.headers['Authorization'] = 'Bearer eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlSWRMaXN0IjpbIjIiXSwidXNlcl9uYW1lIjoiYWRtaW4iLCJjbGllbnRfaWQiOiJncnQtYWRtaW4iLCJvcmdhbml6YXRpb25JZCI6MSwib3JnYW5pemF0aW9uTmFtZXMiOm51bGwsIm9yZ2FuaXphdGlvbklkcyI6IjEsMTAsMTQsMTI4Iiwic2NvcGUiOlsiYWxsIl0sIm5pY2tuYW1lIjoi566h55CG5ZGYIiwib3JnYW5pemF0aW9uSWRMaXN0IjpbIjEiLCIxMCIsIjE0IiwiMTI4Il0sIm9hdXRoX2lkIjpudWxsLCJpZCI6MSwiZXhwIjoxNjY4NzAxNzU2LCJqdGkiOiI4M2UzMDVjNC0xYWM5LTQwOTQtODg0NC1iNWFiZjIzYzVmOWUiLCJvcmdhbml6YXRpb25OYW1lIjoi5pyJ6ZmQ5YWs5Y-4Iiwicm9sZUlkIjpudWxsLCJhdmF0YXIiOiJodHRwczovL3dwaW1nLndhbGxzdGNuLmNvbS9mNzc4NzM4Yy1lNGY4LTQ4NzAtYjYzNC01NjcwM2I0YWNhZmUuZ2lmIiwiYXV0aG9yaXRpZXMiOlsiU1lTQURNSU4iXSwicmVhbE5hbWUiOiLnrqHnkIblkZgiLCJyb2xlSWRzIjoiMiIsImRhdGFQZXJtaXNzaW9uVHlwZUxpc3QiOlsiMyJdLCJ0ZW5hbnRJZCI6IjAiLCJyb2xlTmFtZSI6bnVsbCwicm9sZUtleUxpc3QiOlsiU1lTQURNSU4iXSwicm9sZU5hbWVzIjoi57O757uf566h55CG5ZGYIiwiYWNjb3VudCI6ImFkbWluIn0.NBxSMJ-YRziFMldkeMiVSWRwP2OdK3rFBk5rRl6_mnpE5Ckd-np-jMYdFUvG2SW_FHesXI4xm1c3LaNN6PR5thXveDVo-MD1BdVYpgq73_XZEQDPXrAUPI-OWrpmIUzGxI752qwWtgrSjqV3XeJlt6mUwKk0xD9gE1XaGDfrMzxWinzlLd2iSx4cW7MkaVuU6QnIaX-UD95I-WoE67UmpVtfm6C-m-R1K_AF6YggvhIOce9RugmW5pHS4TgBIf_KDR-g0hWiA_Oca_b9gaXVRKhR6k8mq6xrtM6DIT3A426g3BT-OqfEMTcDB5Jm0BKsHPIe8LSCdGtyfcTnh2tkpQ'; // 请求头携带 token
        config.headers['Authorization'] = localStorage.getItem('ACCESS_TOKEN'); // 请求头携带 token
        config.headers['TenantId'] = 0;
        // 设置请求头
        if (!config.headers['content-type']) {
            // 如果没有设置请求头
            if (config.method === 'post') {
                config.headers['content-type'] = 'application/json'; // post 请求
            } else {
                config.headers['content-type'] = 'application/json'; // 默认类型
            }
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);
// respone拦截器
axios.interceptors.response.use(
    (response) => {
        const res = response.data;
        //这里根据后台返回来设置

        if (response.status === 200) {
            if (response.data.errorCode === '302') {
                window.location.href = '/login';
            }
            if (response.data.errorCode === '304') {
                window.location.href = '/noAuth';
            }
            if (response.data && response.data.code === 'B0001') {
                message.error(response.data?.msg);
            }
            return res;
        }
    },
    (error) => {
        let message = '';

        if (error && error.response) {
            switch (error.response.status) {
                case 302:
                    message = '接口重定向了！';
                    break;
                case 400:
                    message = '参数不正确！';
                    break;
                case 401:
                    message = '您未登录，或者登录已经超时，请先登录！';
                    break;
                case 403:
                    message = '您没有权限操作！';
                    break;
                case 404:
                    message = `请求地址出错: ${error.response.config.url}`;
                    break;
                case 408:
                    message = '请求超时！';
                    break;
                case 409:
                    message = '系统已存在相同数据！';
                    break;
                case 500:
                    message = '服务器内部错误！';
                    break;
                case 501:
                    message = '服务未实现！';
                    break;
                case 502:
                    message = '网关错误！';
                    break;
                case 503:
                    message = '服务不可用！';
                    break;
                case 504:
                    message = '服务暂时无法访问，请稍后再试！';
                    break;
                case 505:
                    message = 'HTTP 版本不受支持！';
                    break;
                default:
                    message = '异常问题，请联系管理员！';
                    break;
            }
        }
        return Promise.reject(message);
    }
);

export default axios;
